/** Host facade: existing imports remain stable when upstream is merged. */
import { writeScenePackage as writePackage, type SceneAsset, type JsiSceneData, type SceneLayerValues, type ScenePackage } from '@jsi/scene-data';

import { materializeSceneImages } from './jsi-image-adapter';

export type { ScenePackage, SceneLayerValues } from '@jsi/scene-data';
export { readScenePackage, sceneDataHash, readScenePackageFromResolver } from '@jsi/scene-data';
export { layersFromSettings, applySceneLayers } from '@jsi/scene-data/legacy-settings';

export const writeScenePackage = async (
    layers: SceneLayerValues,
    sceneId: string,
    assets: SceneAsset[] = [],
    metadata?: JsiSceneData
): Promise<ScenePackage> => writePackage(await materializeSceneImages(layers), sceneId, assets, metadata);
